import BlueCargoLogo from 'components/BlueCargoLogo';
import * as React from 'react';
import { EmailForm } from './EmailForm';
import { Marketing } from './Marketing';

interface Props {
  proceed: (email: string) => void;
}

/**
 * The initial page of the sign up flow that allows
 * the user to enter their email
 */
export const CreateEmail: React.FC<Props> = (props) => {
  return (
    <div className="grid md:grid-cols-2 grid-cols-1 h-screen">
      <div className="flex justify-center md:justify-end p-8 md:pr-32">
        <div className="space-y-16 w-full max-w-[500px]">
          <BlueCargoLogo variant="larger-blue" destination="public-site" />
          <div className="space-y-4">
            <h1 className="font-bold">Create your BlueCargo Account</h1>
            <h4>No credit card required, 14-day free trial for new companies!</h4>
          </div>
          <EmailForm proceed={props.proceed} />
        </div>
      </div>
      <div className="bg-gray-100">
        <Marketing />
      </div>
    </div>
  );
};
CreateEmail.displayName = 'SignUp.CreateEmail';
